import decode from 'jwt-decode';

export const checkToken = () => {
  try {
    const token = localStorage.getItem('token_A');

    if (token) {
      const decoded = decode(token);
      if (!(decoded.exp < Date.now() / 1000)) {
        return [true, decoded];
      }
    }
  } catch (e) {
    console.log(e);
  }
  return [false];
};
